import Button from "./Button";
import Link from "./Link";

const components = {
    Button,
    Link
};

export default components;